import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import { AccordionText } from "AtomicContainers"

const commonStyles = {
  list: {
    margin: 0,
    padding: 0,
    listStyleType: "none"
  },
  description: {
    fontWeight: 200,
    padding: "0 1em 0 0",
    lineHeight: 1.5,
    display: "block"
  },
  price: {
    fontWeight: 600
  }
}

function Compact({ services = [] }) {
  return (
    <div>
      {services.map((service, i) => (
        <AccordionText
          styleName='simple'
          key={service.subOpCode || i}
          name={service.name}
          labelCase="inherit"
          barBorder="top"
          ignorePropsComponents>
          <div style={compactStyles.service}>
            {service.price && (
              <div style={{ ...commonStyles.price, ...compactStyles.price }}>{service.price}</div>
            )}
            {service.description && (
              <div style={commonStyles.description}>{service.description}</div>
            )}
          </div>
        </AccordionText>
      ))}
    </div>
  )
}

const compactStyles = {
  service: {
    display: "flex",
    flexDirection: "column",
    padding: "1em 0"
  },
  price: {
    margin: ".5em 0 1em"
  }
}

function Large({ services }) {
  return (
    <ul style={commonStyles.list}>
      {services.map((service, i) => (
        <li style={largeStyles.service} key={service.subOpCode || i}>
          <div style={largeStyles.content}>
            {service.name && <div style={largeStyles.name}>{service.name}</div>}
            {service.description && (
              <div style={commonStyles.description}>{service.description}</div>
            )}
          </div>
          {service.price && (
            <div style={{ ...commonStyles.price, ...largeStyles.price }}>{service.price}</div>
          )}
        </li>
      ))}
    </ul>
  )
}

const largeStyles = {
  service: {
    boxSizing: "border-box",
    padding: "1.8em 1em 1.2em",
    display: "flex",
    borderTop: "1px solid #aaaaaa",
    margin: 0,
    listStyleType: "none"
  },
  content: {
    flexGrow: 1,
    textAlign: "left"
  },
  name: {
    fontWeight: 600,
    margin: "0 0 1em 0"
  },
  price: {
    flexGrow: 0,
    flexShrink: 0
  }
}

function ServiceListInspect(props = {}) {
  return props.compact ? <Compact {...props} /> : <Large {...props} />
}

ServiceListInspect.propTypes = Compact.propTypes = Large.propTypes = {
  services: PropTypes.array,
  compact: PropTypes.bool
}

export default Radium(ServiceListInspect)



// WEBPACK FOOTER //
// ./src/containers/service-list-inspect/index.jsx